import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FlexContainer } from 'features/common/components/FlexContainer';
import { Input } from '../Input';
import { confirmIcon } from 'assets/images';
import { Information } from './Information';
import { Buttons } from './Buttons.tsx';
import { useMobileView } from 'hooks/useMobileView';
import { useAppSelector } from 'store/hooks';
import { RootState } from 'store';

import { Title, Wrapper, Img } from './OrderPreview.styles';

export const OrderPreview = () => {
	const { t } = useTranslation();
	const isMobile = useMobileView();
	const { isPunchup } = useAppSelector(({ auth }: RootState) => auth);

	const [ticketSent, setTicketSent] = useState<boolean>(false);

	return (
		<Wrapper>
			<FlexContainer flexDirection="column" width={isMobile ? '90%' : '30%'}>
				{ticketSent && (
					<FlexContainer justifyContent="center" width="100%">
						<Img src={confirmIcon} />
					</FlexContainer>
				)}
				<Title className={ticketSent ? 'ticketsSent' : 'center'} isPunchup={isPunchup}>
					{t(ticketSent ? 'boxOffice-ticketsSent' : 'boxOffice-title')}
				</Title>
				<Information ticketSent={ticketSent} />
				<FlexContainer flexDirection="column" gap="32px">
					{!ticketSent && (
						<Input
							id="transactionId"
							name={t('boxOffice-transactionIdLabel')}
							placeholder={t('boxOffice-transactionIdPlaceholder')}
						/>
					)}
					<Buttons setTicketSent={setTicketSent} ticketSent={ticketSent} />
				</FlexContainer>
			</FlexContainer>
		</Wrapper>
	);
};
